import { FormGridField } from "../../components/FormGrid";

export interface BulletsSelectorDefinition {
    name: string;
    id: string;
    label: string;
    items: { label: any; value: string | number }[];
    completeList: { label: any; value: string | number }[];
    schemaName: string;
    enableSearch?: boolean;
    orderByLabel?: boolean;
    exclusive?: boolean;
    disabled?: boolean;
    fieldOverrides?: any;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildBulletsSelectorDefinition({
    name,
    id,
    label,
    items,
    completeList,
    schemaName,
    enableSearch,
    orderByLabel,
    exclusive,
    fieldOverrides,
    disabled
}: {
    name: string;
    id: string;
    label: string;
    enableSearch?: boolean;
    orderByLabel?: boolean;
    items: { label: any; value: string | number }[];
    completeList: { label: any; value: string | number }[];
    schemaName: string;
    exclusive?: boolean;
    fieldOverrides?: any;
    disabled?: boolean;
}): BulletsSelectorDefinition {
    return {
        name,
        id,
        label,
        items,
        enableSearch,
        orderByLabel,
        completeList,
        schemaName,
        exclusive,
        fieldOverrides,
        disabled,
        buildFormGridField: _createBulletsSelectorField
    };
}

function _createBulletsSelectorField(schema): FormGridField {
    const {
        name,
        id,
        label,
        items,
        completeList,
        schemaName,
        fieldOverrides,
        enableSearch,
        exclusive,
        orderByLabel,
        disabled
    } = this;

    return {
        name,
        fieldType: "bulletsSelector",
        fieldOptions: {
            id,
            label,
            completeList,
            items,
            enableSearch,
            exclusive,
            orderByLabel,
            disabled
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        columnClass: "col-12",
        formSpacing: true,
        ...fieldOverrides
    };
}
